import React from 'react'
import {
  Columns,
  RawPeriodInputs,
  useHandler,
  WithLabel,
  LocalizedText,
  IconAction,
  PromiseIconAction,
  TimesIcon,
} from 'labguard-cdk'
import { usePeriodState } from 'src/hooks'
import { NowContext } from 'src/contexts'
import { HourglassHalfIcon, RefreshIcon } from 'src/components/common'
import RelativePeriodInput from '../RelativePeriodInput'
import styles from './PeriodAndRefreshInput.scss'

const PeriodAndRefreshInput = () => {
  const { now, refresh } = NowContext.use()
  const [{ from, to }, updatePeriod] = usePeriodState()
  const value = React.useMemo(() => [from, to], [from, to])
  const onChange = useHandler(([from, to]) => updatePeriod({ from, to }))
  const clearTo = useHandler(() => updatePeriod({ from }))

  // refresh `now` on mount
  React.useEffect(() => {
    refresh()
  }, [refresh])

  return (
    <Columns layout="auto">
      <WithLabel
        icon={HourglassHalfIcon}
        color="secondary-light"
        label={
          <Columns align="center">
            <LocalizedText id="WEB_PERIOD" />
            (&nbsp; <RelativePeriodInput />)
          </Columns>
        }
      >
        {() => (
          <Columns gap="1rem" align="center" layout="1 auto" className={styles.input}>
            <RawPeriodInputs color="secondary-light" value={value} onChange={onChange} now={now} />
            {to ? (
              <IconAction icon={TimesIcon} onClick={clearTo} />
            ) : (
              <PromiseIconAction tooltip={<LocalizedText id="WEB_REFRESH" />} icon={RefreshIcon} onClick={refresh} />
            )}
          </Columns>
        )}
      </WithLabel>
    </Columns>
  )
}

export default PeriodAndRefreshInput
